module.exports = __webpack_public_path__ + "static/st.1-7e097dc176902bf7931d4db06c85e98c.png";